module.exports = __webpack_public_path__ + "img/sweet_inactive.cd1c86c4.png";